import { render } from "./FieldArray.vue?vue&type=template&id=202c8e05&scoped=true"
import script from "./FieldArray.vue?vue&type=script&lang=js"
export * from "./FieldArray.vue?vue&type=script&lang=js"

import "./FieldArray.vue?vue&type=style&index=0&id=202c8e05&scoped=true&lang=css"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c8e05"]])

export default __exports__